import React, { useState, useContext, useEffect } from "react";
import IpdForm from "../components/IpdForm";
import OpdForm from "../components/Opdform";
import { AppContext } from "../ContextApi";

const Intimate_my_claims = () => {
  const [activetab, setactivetab] = useState("IPD");
  const { intimateArray, GlobalintimateVisiblity, tabapiData, featuresType } = useContext(AppContext);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (intimateArray?.length > 0 && tabapiData?.length > 0) {
      const matchedTab = tabapiData.find(
        (dumData) => dumData.policy_type_name === featuresType
      );
      setSelectedOption(matchedTab?.intimate_claim_visibility);
    }
  }, [GlobalintimateVisiblity, intimateArray, tabapiData, featuresType]);

  function showComponent(option) {
    switch (option) {
      case 0:
        return <h5></h5>;
      case 1:
        return (
          <>
            <IPD_Tab activetab={activetab} setactivetab={setactivetab} />
            <OPD_Tab activetab={activetab} setactivetab={setactivetab} />
          </>
        );
      case 2:
        return <IPD_Tab activetab={activetab} setactivetab={setactivetab} />;
      case 3:
        return <OPD_Tab activetab={activetab} setactivetab={setactivetab} />;
      default:
        return null;
    }
  }

  return (
    <>
      <div className="main-escalation-cover-wrapper">
        <div className="claim-status-main-cover-wrapper mt-0">
          <div className="claim-status-header-cover">
            <div className="claims-tabs-section-cover-wrapper mt-0">
              <div className="claims-content-cover-wrapper">
                <div className="intimate-claims-main-wrapper-cover mt-0">
                  <div className="container">
                    <div className="network-hospital-heading">
                      <h3 className="text-center">Intimate my claims</h3>
                    </div>

                    {/* Tabs */}
                    <div className="intimate-claims-main-content-cover">
                      <div className="opd-ipd-tabs-cover d-flex justify-content-center mb-5">
                        {showComponent(selectedOption)}
                      </div>

                      {/* Form */}
                      <div className="intimate-claims-form-main-cover">
                        <div className="row">
                          <div className="col-lg-12 order-lg-0 order-1">
                            <div className="intimate-claims-form-box">
                              {activetab === "IPD" ? <IpdForm /> : <OpdForm />}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const IPD_Tab = ({ activetab, setactivetab }) => (
  <div
    className={activetab === "IPD" ? "active-tab opd-ipd-tab-box" : "opd-ipd-tab-box"}
    onClick={() => setactivetab("IPD")}
  >
    <h3>IPD</h3>
  </div>
);

const OPD_Tab = ({ activetab, setactivetab }) => (
  <div
    className={activetab === "OPD" ? "active-tab opd-ipd-tab-box" : "opd-ipd-tab-box"}
    onClick={() => setactivetab("OPD")}
  >
    <h3>OPD</h3>
  </div>
);

export default Intimate_my_claims;
